import FormattedMessage from 'I18n/components/FormattedMessage';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { Select } from 'foundations-components/transitional/components/Select';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { TOPIC_CLUSTERS_DASHBOARD_LINK, TopicTypes } from '../data/topicEditor/constants';
import { Button } from 'foundations-components/transitional/components/Button';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ClusterDropdown = ({
  options,
  value,
  canCreateCluster,
  onOpenCreateTopicDialog,
  onClusterChange
}) => {
  return /*#__PURE__*/_jsx(FormControl, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "xray-recommendation-lib.seo.topicEditor.clusterDropdown.label"
    }),
    "data-test-id": "topic-editor-cluster-dropdown",
    children: /*#__PURE__*/_jsx(Select, {
      "data-test-id": "cluster-select",
      minimumSearchCount: 0,
      options: options,
      onChange: onClusterChange,
      value: value,
      dropdownFooter: /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(Tooltip, {
            title: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "xray-recommendation-lib.seo.topicEditor.clusterDropdown.footer.maxClusterToolTip"
            }),
            disabled: canCreateCluster,
            children: /*#__PURE__*/_jsx(Button, {
              use: "link",
              disabled: !canCreateCluster,
              onClick: () => {
                onOpenCreateTopicDialog(TopicTypes.CLUSTER);
              },
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "xray-recommendation-lib.seo.topicEditor.clusterDropdown.footer.createCluster"
              })
            })
          })
        }), /*#__PURE__*/_jsx(Text, {
          marginBlock: "200",
          as: "p",
          children: /*#__PURE__*/_jsx(Button, {
            use: "link",
            external: true,
            href: TOPIC_CLUSTERS_DASHBOARD_LINK,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "xray-recommendation-lib.seo.topicEditor.clusterDropdown.footer.editClusters"
            })
          })
        })]
      }),
      placeholder: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "xray-recommendation-lib.seo.topicEditor.clusterDropdown.placeholder"
      }),
      searchable: true
    })
  });
};